import React, { useEffect, useState } from 'react';
import { RootState, useSelector } from '../../redux/store';
import useLocales from '../../hooks/useLocales';
import getSteelMakerName from '../../utils/getSteelMakerName';
import type { ICellRendererParams } from 'ag-grid-community';

const SteelMakerCellRenderer = (params: ICellRendererParams): React.ReactElement => {
  const steelMakerCodes: string[] = Array.isArray(params.value) ? params.value : [params.value];
  // console.log(steelMakerCodes);
  const { currentLang } = useLocales();
  const { steelMaker } = useSelector((state: RootState) => state.options);
  const [displayName, setDisplayName] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  useEffect(() => {
    // 鉄鋼メーカーコードの配列を鉄鋼メーカー名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
    const mappedCodes: string[] = steelMakerCodes.map((code) => {
      const steelMakerName: string = getSteelMakerName(code, steelMaker, currentLang.value);
      return steelMakerName;
    });
    setDisplayName(mappedCodes.join(', '));
  }, [steelMaker, currentLang]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <span className="steel-maker-name">{displayName}</span>;
};

export default SteelMakerCellRenderer;
